import { combineReducers } from "redux";

import LayoutReducer from "./layouts/reducer";
import dashboardReducer from "../slices/dashboard/dashboardSlice";
import UserDetailsReducer from "./UserDeatils/dashboardWidgetDataSlice";
import CompanyDetailsReducer from "./CompanyDetails/getCompanyDetailsSlice";
import EvidenceViewReducer from "./EvidenceView/getEvidenceSlice";
import SupportTicketsReducer from "./GetSupportTickets/reducer";
import SupportTicketDetailsReducer from "./GetSupportTicketDetails/reducer";
import LicenseListReducer from "./LicenseList/reducer";
import CcfDataReducer from "./ProjectTask/GetCCF/reducer"

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Dashboard: dashboardReducer,
    UserDetails: UserDetailsReducer,
    CompanyDetails: CompanyDetailsReducer,
    EvidenceView: EvidenceViewReducer,
    SupportTickets: SupportTicketsReducer,
    SupportTicketDetails: SupportTicketDetailsReducer,
    LicenseList: LicenseListReducer,
    CCFData: CcfDataReducer
});

export default rootReducer;